// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MS_button {}

.MS_button:focus {
    background-color: #83a4cf !important;
}

.MS_button:hover {
    background-color: #83a4cf !important;
}

.ms_btn.btn:focus,
.ms_btn.btn:focus-visible,
.ms_btn.btn:focus-within,
.ms_btn.btn:hover,
.ms_btn.btn:visited,
.ms_btn.btn:active,
.ms_btn.btn:target {
    color: #fff !important;
    background-color: #83a4cf !important;
    border-color: #83a4cf !important;
}

.ms_btn.btn {
    color: #83a4cf !important;
    border-color: #83a4cf !important;
}

.ms_btn.btn.active {
    color: #ffffff !important;
    border-color: #83a4cf !important;
    background-color: #83a4cf !important;
}

.cursor_pointer {
    cursor: pointer;
}


.custom-tooltip .tooltip-inner {
    background-color: white !important;
    color: rgb(34, 32, 32) !important;
    border: 1px solid #ccc;
    font-size: 0.8rem;
    padding: 4px
        /* optional */
}

.custom-tooltip.bs-tooltip-top .tooltip-arrow::before,
.custom-tooltip.bs-tooltip-bottom .tooltip-arrow::before,
.custom-tooltip.bs-tooltip-left .tooltip-arrow::before,
.custom-tooltip.bs-tooltip-right .tooltip-arrow::before {
    border-top-color: white !important;
    border-bottom-color: white !important;
    border-left-color: white !important;
    border-right-color: white !important;
}


.ms_btn_close.btn:focus,
.ms_btn_close.btn:focus-visible,
.ms_btn_close.btn:focus-within,
.ms_btn_close.btn:hover,
.ms_btn_close.btn:visited,
.ms_btn_close.btn:active,
.ms_btn_close.btn:target {
    color: #fff !important;
    background-color: #83a4cf !important;
    border-color: #83a4cf !important;
}

.ms_btn_close.btn {
    color: #83a4cf !important;
    border-color: #83a4cf !important;
}

.ms_btn_close.btn.active {
    color: #ffffff !important;
    border-color: #83a4cf !important;
    background-color: #83a4cf !important;
}

.ms_btn_solid_Bus.btn {
    color: #ffffff !important;
    transition: transform 0.1s ease, background-color 0.2s ease, border-color 0.2s ease;
}

.ms_btn_solid_Bus.btn:active {
    transform: scale(0.99);
    /* press effect */
    background-color: #5f85b3 !important;
    border-color: #5f85b3 !important;
}

.ms_btn_solid_Bus.btn.active {
    color: #ffffff !important;
    background-color: #83a4cf !important;
    border-color: #83a4cf !important;
}

.ms_btn_solid_Bus.btn.primary {
    background-color: #83a4cf !important;
    border-color: #83a4cf !important;
}



.ms_btn_solid_Bus.btn.primary:hover,
.ms_btn_solid_Bus.btn.primary:focus,
.ms_btn_solid_Bus.btn.primary:focus-visible,
.ms_btn_solid_Bus.btn.primary:focus-within,
.ms_btn_solid_Bus.btn.primary:visited,
.ms_btn_solid_Bus.btn.primary:target {
    color: #ffffff !important;
    background-color: #6f96c0 !important;
    border-color: #6f96c0 !important;
}


.ms_btn_solid_Bus.btn.secondary {
    background-color: #a2a4a7 !important;
    border-color: #8c8d8d !important;
}

.ms_btn_solid_Bus.btn.secondary:hover,
.ms_btn_solid_Bus.btn.secondary:focus,
.ms_btn_solid_Bus.btn.secondary:focus-visible,
.ms_btn_solid_Bus.btn.secondary:focus-within,
.ms_btn_solid_Bus.btn.secondary:visited,
.ms_btn_solid_Bus.btn.secondary:target {
    color: #ffffff !important;
    background-color: #878889 !important;
    border-color: #717272 !important;
}

/* input[type="range"]::-webkit-slider-runnable-track {
    pointer-events: none;
} */`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/Mileagesaarathi_bus/style.css"],"names":[],"mappings":"AAAA,YAAY;;AAEZ;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;;;;;;IAOI,sBAAsB;IACtB,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;IAChC,oCAAoC;AACxC;;AAEA;IACI,eAAe;AACnB;;;AAGA;IACI,kCAAkC;IAClC,iCAAiC;IACjC,sBAAsB;IACtB,iBAAiB;IACjB,WAAW;QACP,aAAa;AACrB;;AAEA;;;;IAII,kCAAkC;IAClC,qCAAqC;IACrC,mCAAmC;IACnC,oCAAoC;AACxC;;;AAGA;;;;;;;IAOI,sBAAsB;IACtB,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;IAChC,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,mFAAmF;AACvF;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;IACpC,gCAAgC;AACpC;;;;AAIA;;;;;;IAMI,yBAAyB;IACzB,oCAAoC;IACpC,gCAAgC;AACpC;;;AAGA;IACI,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;;;;;;IAMI,yBAAyB;IACzB,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;;GAEG","sourcesContent":[".MS_button {}\n\n.MS_button:focus {\n    background-color: #83a4cf !important;\n}\n\n.MS_button:hover {\n    background-color: #83a4cf !important;\n}\n\n.ms_btn.btn:focus,\n.ms_btn.btn:focus-visible,\n.ms_btn.btn:focus-within,\n.ms_btn.btn:hover,\n.ms_btn.btn:visited,\n.ms_btn.btn:active,\n.ms_btn.btn:target {\n    color: #fff !important;\n    background-color: #83a4cf !important;\n    border-color: #83a4cf !important;\n}\n\n.ms_btn.btn {\n    color: #83a4cf !important;\n    border-color: #83a4cf !important;\n}\n\n.ms_btn.btn.active {\n    color: #ffffff !important;\n    border-color: #83a4cf !important;\n    background-color: #83a4cf !important;\n}\n\n.cursor_pointer {\n    cursor: pointer;\n}\n\n\n.custom-tooltip .tooltip-inner {\n    background-color: white !important;\n    color: rgb(34, 32, 32) !important;\n    border: 1px solid #ccc;\n    font-size: 0.8rem;\n    padding: 4px\n        /* optional */\n}\n\n.custom-tooltip.bs-tooltip-top .tooltip-arrow::before,\n.custom-tooltip.bs-tooltip-bottom .tooltip-arrow::before,\n.custom-tooltip.bs-tooltip-left .tooltip-arrow::before,\n.custom-tooltip.bs-tooltip-right .tooltip-arrow::before {\n    border-top-color: white !important;\n    border-bottom-color: white !important;\n    border-left-color: white !important;\n    border-right-color: white !important;\n}\n\n\n.ms_btn_close.btn:focus,\n.ms_btn_close.btn:focus-visible,\n.ms_btn_close.btn:focus-within,\n.ms_btn_close.btn:hover,\n.ms_btn_close.btn:visited,\n.ms_btn_close.btn:active,\n.ms_btn_close.btn:target {\n    color: #fff !important;\n    background-color: #83a4cf !important;\n    border-color: #83a4cf !important;\n}\n\n.ms_btn_close.btn {\n    color: #83a4cf !important;\n    border-color: #83a4cf !important;\n}\n\n.ms_btn_close.btn.active {\n    color: #ffffff !important;\n    border-color: #83a4cf !important;\n    background-color: #83a4cf !important;\n}\n\n.ms_btn_solid_Bus.btn {\n    color: #ffffff !important;\n    transition: transform 0.1s ease, background-color 0.2s ease, border-color 0.2s ease;\n}\n\n.ms_btn_solid_Bus.btn:active {\n    transform: scale(0.99);\n    /* press effect */\n    background-color: #5f85b3 !important;\n    border-color: #5f85b3 !important;\n}\n\n.ms_btn_solid_Bus.btn.active {\n    color: #ffffff !important;\n    background-color: #83a4cf !important;\n    border-color: #83a4cf !important;\n}\n\n.ms_btn_solid_Bus.btn.primary {\n    background-color: #83a4cf !important;\n    border-color: #83a4cf !important;\n}\n\n\n\n.ms_btn_solid_Bus.btn.primary:hover,\n.ms_btn_solid_Bus.btn.primary:focus,\n.ms_btn_solid_Bus.btn.primary:focus-visible,\n.ms_btn_solid_Bus.btn.primary:focus-within,\n.ms_btn_solid_Bus.btn.primary:visited,\n.ms_btn_solid_Bus.btn.primary:target {\n    color: #ffffff !important;\n    background-color: #6f96c0 !important;\n    border-color: #6f96c0 !important;\n}\n\n\n.ms_btn_solid_Bus.btn.secondary {\n    background-color: #a2a4a7 !important;\n    border-color: #8c8d8d !important;\n}\n\n.ms_btn_solid_Bus.btn.secondary:hover,\n.ms_btn_solid_Bus.btn.secondary:focus,\n.ms_btn_solid_Bus.btn.secondary:focus-visible,\n.ms_btn_solid_Bus.btn.secondary:focus-within,\n.ms_btn_solid_Bus.btn.secondary:visited,\n.ms_btn_solid_Bus.btn.secondary:target {\n    color: #ffffff !important;\n    background-color: #878889 !important;\n    border-color: #717272 !important;\n}\n\n/* input[type=\"range\"]::-webkit-slider-runnable-track {\n    pointer-events: none;\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
